import { render, staticRenderFns } from "./HbPageHeader.vue?vue&type=template&id=67a9685e&scoped=true&"
import script from "./HbPageHeader.vue?vue&type=script&lang=js&"
export * from "./HbPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./HbPageHeader.vue?vue&type=style&index=0&id=67a9685e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9685e",
  null
  
)

export default component.exports